// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_il-0";
export var fileCarousel = "_il-2";
export var removeFileButton = "_il-1";